import "core-js";
import { createApp } from "vue";
import App from "./app/App.vue";
import router from "@/router/Router";
import { createPinia } from "pinia";
import "@/assets/tailwind.css";
import '@/assets/main.css'

const app = createApp(App);
const pinia = createPinia();

app
  .use(pinia)
  .use(router)
  .mount("#app");
